import React, { useState, useEffect } from "react";
import ProductsSidebar from "./ProductsSidebar";
import { SlidersHorizontal } from "lucide-react";

const ProductsLayout = ({
	children,
	products,
	filters,
	onFilter,
	onReset,
	subcategories,
	onSubcategorySelect,
	selectedSubcategory,
}) => {
	const [sidebarOpen, setSidebarOpen] = useState(false);

	// lock page scroll while the mobile drawer is open
	useEffect(() => {
		if (!sidebarOpen) return;
		const prev = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = prev;
		};
	}, [sidebarOpen]);

	return (
		<div className="mx-auto w-full max-w-[1320px] px-3 sm:px-4 py-4 md:py-6">
			{/* Mobile filter button */}
			<div className="md:hidden mb-4">
				<button
					type="button"
					onClick={() => setSidebarOpen(true)}
					className="w-full flex items-center justify-center gap-2 py-2.5 rounded-md border border-yellow-800 text-yellow-800 text-sm font-semibold bg-white"
				>
					<SlidersHorizontal size={16} />
					Filters
				</button>
			</div>

			<div className="flex flex-col md:flex-row gap-5">
				{/* Sidebar: drawer on mobile, sticky column on desktop */}
				<aside
					className={`fixed inset-y-0 left-0 z-50 w-[88%] max-w-sm bg-white overflow-y-auto transform transition-transform duration-300
						md:static md:z-auto md:w-64 lg:w-72 md:max-w-none md:shrink-0 md:translate-x-0 md:bg-transparent md:overflow-visible
						md:sticky md:top-4 md:self-start md:max-h-[calc(100vh-2rem)] md:overflow-y-auto
						${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
				>
					<ProductsSidebar
						onClose={() => setSidebarOpen(false)}
						filters={filters}
						onFilter={onFilter}
						onReset={onReset}
						subcategories={subcategories}
						onSubcategorySelect={onSubcategorySelect}
						selectedSubcategory={selectedSubcategory}
					/>
				</aside>

				{sidebarOpen && (
					<div
						className="fixed inset-0 z-40 bg-black/50 md:hidden"
						onClick={() => setSidebarOpen(false)}
					/>
				)}

				<div className="flex-1 min-w-0">{children}</div>
			</div>
		</div>
	);
};

export default ProductsLayout;